export default __webpack_public_path__ + "static/media/bg2.2608af6c.png";